module.exports = __webpack_public_path__ + "fonts/LavishlyYours-Regular.ac87d91e.ttf";